export default __webpack_public_path__ + "static/media/Safemart_bad.537b9bac.webp";